<template>
  <div class="post-new">
    <div class="Page">
      <div class="leftMap">
        <!-- 重庆地图 -->
        <div
          id="chartChongqing"
          ref="myEchart"
          style="position: relative; bottom: 43px"
        ></div>
        <!-- 全国地图 -->
        <div class="chinaBox">
          <div class="chinaBorder"></div>
          <div id="chartChina" ref="myEchart" style="position: relative"></div>
        </div>
        <!-- 箭头 -->
        <div class="long-arrow"></div>
        <div class="long-arrow long-arrow1"></div>
      </div>

      <!-- <div
        id="ChartChina"
        ref="chartChinaEchart"
        style="position: relative; bottom: 43px"
      ></div> -->
      <div id="box">
        <div class="box_left">
          <div class="box_title">全部({{ city.length }})</div>
          <div class="cityCont">
            <div v-for="(item, index) in city" :key="index" class="cityBox">
              <!-- <div v-if="((city)[index]).name!=((city)[index+1]).name&&index+1<city.length" class="city"> -->
              <!-- <div v-if="((city)[index]).name!=((city)[index-1]).name" class="city"> -->
              <div class="city">
                {{ city[index].name }}
              </div>
              <!-- <div class="city">
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</div> -->
              <div>
                <div
                  v-for="(items, indexs) in item.children"
                  :key="indexs + 'a'"
                  class="positionBox"
                >
                  <!--<div class="zhan">
                   {{((item.children)[indexs+'a']).site}} 
                  {{ items.site }}
                </div>-->
                  <div class="positionLine"></div>
                  <div class="xq">
                    <img src="@/img/icon@2x.png" />
                    <span>{{ items.position }}</span>
                    <!-- {{((item.children)[indexs+'a']).position}} -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="cityBox">
						<div class="city">
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						</div>
						<div class="zhan">
							站点一
						</div>
						<div class="xq">
							重庆市江北区文化产业园2栋12楼232号
						</div>
					</div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 引入基本模板
import echarts from "echarts";
import "../../node_modules/echarts/map/js/china.js"; // 引入中国地图数据
// import '@/assets/js/china.js' //引入中国地图数据
import chongqing from "@/assets/chongqing.json";
export default {
  name: "projectMap",
  components: {},
  data() {
    return {
      selectVal1: "",
      ifbox: true,
      TipsList: [],
      value3: "",
      city: [
        {
          name: "重庆市南川区站点",
          children: [
            {
              site: "站点一",
              position:
                "重庆市南川区西城街道办事处隆化大道12号（总商会大厦）1幢1-14-4",
            },
          ],
        },
        {
          name: "重庆市荣昌区站点",
          children: [
            {
              site: "站点一",
              position: "重庆市荣昌区昌州街道昌龙大道37号2栋10-3",
            },
          ],
        },
        {
          name: "重庆市永川区站点",
          children: [
            {
              site: "站点一",
              position: "重庆市永川区星光大道222号7幢2-3",
            },
          ],
        },
        {
          name: "重庆市潼南区站点",
          children: [
            {
              site: "站点一",
              position: "重庆市潼南区桂林街道办事处正西街32号",
            },
          ],
        },
        {
          name: "重庆市大足区站点",
          children: [
            {
              site: "站点一",
              position: "重庆市大足区龙岗街道办事处双塔路62号",
            },
          ],
        },
        {
          name: "重庆市铜梁站点",
          children: [
            {
              site: "站点一",
              position: "重庆市铜梁区巴川街道办事处营盘路224号",
            },
          ],
        },
        {
          name: "重庆市酉阳站点",
          children: [
            {
              site: "站点一",
              position:
                "重庆市酉阳土家族苗族自治县钟多街道桃花源大道中段93号附60号、61号",
            },
          ],
        },
      ],
      pointData: [
        {
          name: "重庆市南川区站点",
          profile: "一",

          coord: [
            107.093072,
            29.172254, //坐标，通过高德
          ],
          selected: false,
          symbolSize: [30, 30],
          //自定义图片的 路径
          symbol: "image://" + require("@/img/icon_dot@2x.png"),
        },
        {
          name: "重庆市荣昌区站点",
          profile: "2",

          coord: [
            105.614223,
            29.420532, //坐标，通过高德
          ],
          selected: false,
          symbolSize: [30, 30],
          //自定义图片的 路径
          symbol: "image://" + require("@/img/icon_dot@2x.png"),
        },
        {
          name: "重庆市永川区站点",
          profile: "3",

          coord: [
            105.928276,
            29.339442, //坐标，通过高德
          ],
          selected: false,
          symbolSize: [30, 30],
          //自定义图片的 路径
          symbol: "image://" + require("@/img/icon_dot@2x.png"),
        },
        {
          name: "重庆市潼南区站点",
          profile: "4",

          coord: [
            105.845897,
            30.197416, //坐标，通过高德
          ],
          selected: false,
          symbolSize: [30, 30],
          //自定义图片的 路径
          symbol: "image://" + require("@/img/icon_dot@2x.png"),
        },
        {
          name: "重庆市大足区站点",
          profile: "5",

          coord: [
            105.71927,
            29.705684, //坐标，通过高德
          ],
          selected: false,
          symbolSize: [30, 30],
          //自定义图片的 路径
          symbol: "image://" + require("@/img/icon_dot@2x.png"),
        },
        {
          name: "重庆市铜梁站点",
          profile: "6",

          coord: [
            106.062629,
            29.845939, //坐标，通过高德
          ],
          selected: false,
          symbolSize: [30, 30],
          //自定义图片的 路径
          symbol: "image://" + require("@/img/icon_dot@2x.png"),
        },
        {
          name: "重庆市酉阳站点",
          profile: "7",

          coord: [
            108.789722,
            28.818145, //坐标，通过高德
          ],
          selected: false,
          symbolSize: [30, 30],
          //自定义图片的 路径
          symbol: "image://" + require("@/img/icon_dot@2x.png"),
        },
      ],
      chinaData: [
        {
          name: "重庆",
          label: { color: "#858BA4" },
          itemStyle: {
            normal: {
              borderColor: "#0C38D9", //图形的描边颜色
              borderWidth: 0,
              areaColor: "#0C38D9",
            },
            emphasis: {
              disabled: true,
              // show: false,
            },
          },
          select: {
            disabled: true,
            show: false,
          },
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.ChinaMap();
      this.drawMap();
    });
  },
  methods: {
    // 绘制重庆市地图
    drawMap() {
      let that = this;
      this.myChart = this.$echarts.init(
        document.getElementById("chartChongqing")
      );
      this.$echarts.registerMap("chongqing", chongqing);
      var markPointData = this.pointData;
      var option = {
        geo: [
          // 主地图
          {
            map: "chongqing",
            // top: "10%",
            // zlevel: 4,
            // layoutSize: '1000%', // 控制地图尺寸（地图的宽度和高度都会改变）
            aspectScale: 0.95, // 控制地图长宽比（此值越小地图越窄，越大地图越宽）
            zlevel: -2,
            zoom: 1.2,
            // roam: false,
            roam: false, //支持拖拽缩放
            scaleLimit: {
              //滚轮缩放的极限控制
              min: 0.5, //缩放最小大小
              max: 5, //缩放最大大小
            },

            itemStyle: {
              // 设置背景色
              normal: {
                shadowOffsetX: 0,
                // shadowOffsetY: 8,
                areaColor: "#0C38D9", // 背景
                areaColor: "#fff", // 背景

                // shadowColor: "#4CB9DD", // 背景色
                // borderColor: "#698AFF",
                // borderWidth: 0,
                // shadowBlur: 3,
                // shadowOffsetX: 4,
                // shadowOffsetY: 5,
              },
              emphasis: {
                areaColor: "#0C38D9", // 背景
                label: {
                  show: false,
                },
              },
            },
          },
        ],
        series: [
          {
            name: "",
            type: "map",
            // type: "map3D", // 系列类型
            // name: "map3D", // 系列名称
            map: "chongqing",
            // zlevel: 1,
            // 背景   // 环境贴图，支持純颜色值，渐变色，全景贴图的 url。默认为 'auto'，在配置有 light.ambientCubemap.texture 的时候会使用该纹理作为环境贴图。否则则不显示环境贴图。
            // environment: this.$echarts.graphic.LinearGradient(
            //   0,
            //   0,
            //   0,
            //   1,
            //   [
            //     {
            //       // 配置为垂直渐变的背景
            //       offset: 0,
            //       color: "#00aaff", // 天空颜色
            //     },
            //     {
            //       offset: 0.7,
            //       color: "#998866", // 地面颜色
            //     },
            //     {
            //       offset: 1,
            //       color: "#998866", // 地面颜色
            //     },
            //   ],
            //   false
            // ),
            zoom: 1.2,
            aspectScale: 0.95,
            // zoom: 2,
            //缩放
            roam: false, //支持拖拽缩放
            scaleLimit: {
              //滚轮缩放的极限控制
              min: 0.5, //缩放最小大小
              max: 5, //缩放最大大小
            },
            //缩放
            label: {
              show: false, // 显示标签
              borderColor: "#fff", // 边框颜色
              borderWidth: 2, // 边框宽度
              color: "#000", // 文字颜色
              // show: true, //展示区县名
              textStyle: {
                // 标签的字体样式
                // color: "#000", // 地图初始化区域字体颜色
                // fontSize: 12, // 字体大小
                // opacity: 1, // 字体透明度
                // backgroundColor: "rgba(0,23,11,0)", // 字体背景色
              },
              normal: {
                show: false,
                position: "inside", //
                // offset: [0, 0],
                formatter: (params) => {
                  let result = "";
                  if (params.name.length >= 8) {
                    result = `{title1|${params.name.substr(0, 2)}}县`;
                  }
                  // ，江北、渝中、渝北、沙坪坝、九龙坡、南岸、大渡口、北碚、巴南
                  else if (
                    params.name == "渝中区" ||
                    params.name == "沙坪坝区" ||
                    params.name == "南岸区" ||
                    params.name == "大渡口区" ||
                    params.name == "江北区" ||
                    params.name == "渝北区" ||
                    params.name == "九龙坡区" ||
                    params.name == "北碚区" ||
                    params.name == "巴南区"
                  ) {
                    result = `{title2|${params.name}}`;
                  } else {
                    result = `{title13|${params.name}}`;
                  }
                  return result;
                },
                rich: {
                  title1: {
                    fontSize: 14,
                  },
                  title2: {
                    fontSize: 0,
                    show: false,
                  },
                  title3: {
                    borderColor: "#fff",
                    borderWidth: 1,
                    fontSize: 14,
                  },
                },
              },
            },
            data: this.chinaData,
            // 点单和阵地才有
            markPoint: {
              //图标标注。
              label: {
                normal: {
                  show: false,
                  trigger: "item",
                  formatter: function (params) {},
                },
                triggerOn: "click",
              },
              itemStyle: {
                normal: {
                  color: "none",
                  areaColor: {
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(178,63,255, .4)", // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "rgba(30,252,252, .5)", // 100% 处的颜色
                      },
                    ],
                  },
                },
              },
              // data: this.markPointData,
              data: markPointData,
            },
            // 原
            itemStyle: {
              normal: {
                borderWidth: 1, //地图边框宽度
                borderColor: "#365BDF", //地图边框颜色
                areaColor: "#698aff", //地图颜色
              },
              emphasis: {
                //选中省份的颜色
                areaColor: "#4971FF",
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowBlur: 0,
                borderWidth: 1,
                shadowColor: "#fff",
              },
            },
            select: {
              label: {
                // color: "#fff",
                color: "#000",
                fontSize: 14,
                // textBorderColor: "rgba(0,0,0,.2)",
                // textBorderWidth: 2,
              },
              itemStyle: {
                areaColor: "#698AFF",
              },
            },
          },
        ],
      };
      this.myChart.setOption(option);
      this.myChart.on("mouseover", function (params) {
        return;
        // clearInterval(that.timer);
        var area = that.areaCode.filter((item, i) => {
          // if (item.areaName == params.name) {
          if (item.name == params.name) {
            that.areaIndex = i;
          }
          // return item.areaName == params.name;
          return item.name == params.name;
        })[0];
        var aIndex = params.dataIndex;
        // that.getData(area.areaCode, area.areaName, false, aIndex, "allMap");
        that.getData(area.code, area.name, false, aIndex, "allMap");
      });
      // 绑定 mouseout 事件
      this.myChart.on("mouseout", (params) => {
        return;
      });
      this.myChart.setOption(option);
      // 响应式变化
      window.addEventListener("resize", () => this.myChart.resize(), false);
    },
    selectChange(e) {},
    ChinaMap() {
      var that = this;
      //模拟数据
      let data = [
        {
          name: "重庆",
          value: 90,
          num: 5,
          id: 8,
        },
        // {
        //   name: "四川",
        //   value: 102,
        //   num: 15,
        //   id: 16,
        // },
        // {
        //   name: "广东",
        //   value: 140,
        //   num: 30,
        //   id: 20,
        // },
        // {
        //   name: "湖南",
        //   value: 150,
        //   num: 40,
        //   id: 30,
        // },
        // {
        //   name: "北京",
        //   value: 150,
        //   num: 40,
        //   id: 30,
        // },
        // {
        //   name: "上海",
        //   value: 150,
        //   num: 40,
        //   id: 30,
        // },
      ];
      // 地图加点
      // let geoCoordMap = {
      //   重庆: [106.5, 29.62],
      //   四川: [104.08, 30.639518],
      //   湖南: [113.016749, 28.198502],
      //   广东: [114.09134, 22.54602],
      //   北京: [116.348262, 39.969554],
      //   上海: [121.075046, 30.937771],
      // };
      // var convertData = function (data) {
      //   var res = [];
      //   for (var i = 0; i < data.length; i++) {
      //     var geoCoord = geoCoordMap[data[i].name];
      //     if (geoCoord) {
      //       res.push({
      //         name: data[i].name,
      //         value: geoCoord.concat(data[i].value),
      //         //一定要有value这个字段,写法一定要geoCoord.concat(data[i].itemId),
      //         num: geoCoord.concat(data[i].num),
      //         id: geoCoord.concat(data[i].id),
      //       });
      //     }
      //   }
      //   return res;
      // };
      let chartChina = echarts.init(document.getElementById("chartChina")); //这里是为了获得容器所在位置
      window.onresize = chartChina.resize;
      chartChina.setOption({
        //进行相关配置
        // backgroundColor: '#4971FF', //地图背景色
        geo: {
          //这个是重点配置区
          map: "china", //表示中国地图
          label: {
            normal: {
              show: false, //是否显示对应地名
              textStyle: {
                //字体颜色
                color: "#fff",
              },
            },
            emphasis: {
              show: false,
              textStyle: {
                color: "#ff007f",
              },
            },
          },
          roam: false, //是否可以缩放
          itemStyle: {
            normal: {
              borderWidth: 0, //地图边框宽度
              borderColor: "#698aff", //地图边框颜色
              areaColor: "#698aff", //地图颜色
            },
            emphasis: {
              //选中省份的颜色
              areaColor: "#4971FF",
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 0,
              borderWidth: 0,
              // shadowColor: "#fff",
            },
          },
        },
        //滑动显示数据
        //tooltip:{
        //trigger:'item',
        //formatter:function(params) {
        //return params.name + '已接入:'+params.data.num[2];
        //}
        //},
        series: [
          // {
          //   name: "散点",
          //   type: "scatter",
          //   coordinateSystem: "geo",
          //   //color:function(params){
          //   //var colorlist = ['#F56C6C','#409EFF'];

          //   //return colorlist[0];
          //   //},//点的颜色
          //   data: convertData(data),
          //   symbolSize: 25, //点的大小
          //   symbol: "pin", //点的样式
          //   cursor: "pointer", //鼠标放上去的效果
          //   label: {
          //     normal: {
          //       //默认展示
          //       show: false,
          //     },
          //     emphasis: {
          //       //滑过展示
          //       show: false,
          //     },
          //   },
          //   itemStyle: {
          //     color: function (params) {
          //       var colorlist = ["#fff", "#409EFF"];

          //       return colorlist[0];
          //     }, //点的颜色
          //     emphasis: {
          //       // borderColor: '#5c8f6e',
          //       // borderWidth: 5
          //     },
          //   },
          // },
          {
            type: "map",
            map: "china",
            geoIndex: 0,
            aspectScale: 0.75,
            tooltip: {
              show: true,
            },
          },
        ],
      });

      // 通过代码高亮特定省份（如广东）
      chartChina.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        name: "重庆",
      });
    },
    //点击地点显示对应位置数据
    // boxPosition() {
    // 	var e = event || window.event;
    // 	var x = e.clientX - 233 + "px"
    // 	var y = e.clientY - 510 + "px"
    // 	clearTimeout(t)
    // 	var t = setTimeout(function() {
    // 		document.getElementById('box').style.top = y
    // 		document.getElementById('box').style.left = x
    // 	}, 50);
    // 	t
    // },
  },
};
</script>

<style scoped>
.leftMap {
  position: relative;
}
#chartChongqing {
  /* width: 50%;
  height: 390px; */
  /* width: 840px;
  height: 460px; */
  /* bottom: -43px; */
  width: 780px;
  height: 430px;
  left: -2%;
}
/* 中国地图 */
.chinaBox {
  position: relative;
  left: 74%;
  bottom: 14%;
  width: 500px;
}
#chartChina {
  position: absolute;
  /* width: 50%;
  height: 390px; */
  /* width: 840px;
  height: 460px; */
  /* bottom: -43px; */
  width: 240px;
  height: 130px;
  left: -10%;
  top: 6%;
  /* border: 1px solid #698aff; */
}
.chinaBorder {
  position: absolute;
  width: 140px;
  height: 120px;
  border: 1px solid #698aff;
}
/* 箭头 */
.long-arrow {
  position: absolute;
  bottom: 47%;
  right: -10.5%;
  width: 350px;
  height: 1px;
  background-color: #dee5ff;
  margin: 50px;
  transform: rotate(82deg);
}

.long-arrow::after {
  content: "";
  position: absolute;
  right: -8px; /* 调整三角形位置 */
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid #dee5ff; /* 三角形大小 */
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
}
/* 箭头 */
.long-arrow1 {
  bottom: 21.6%;
  right: 10.5%;
  width: 413px;
  transform: rotate(14deg);
}
.Page {
  /* width: 1140px; */
  padding: 0 360px 0 252px;
  display: flex;
  /* border: 1px solid black; */
}

#box {
  /* opacity: 0.6; */
  /* margin-top: 20px; */
  width: 50%;
  /* height: 418px; */
  height: 472px;

  line-height: 29px;
  color: #fefefe;
  font-size: 14px;
  background: rgba(156, 172, 255, 0.1);
  border: 1px solid #9cacff;
}

.box_left {
  width: 96%;
  margin: 0 auto;
}

.box_title {
  width: 100%;
  height: 67px;
  border-bottom: 1px solid #9cacff;
  line-height: 67px;
  font-size: 18px;
  font-family: PingFang HK;
  font-weight: 500;
  color: #fefefe;
}

.close-box {
  float: right;
  font-size: 15px;
}
.positionBox {
  width: 100%;
  display: flex;
}
.cityCont {
  overflow-y: scroll;
  max-height: 390px;
  overflow-x: hidden;
}
::-webkit-scrollbar {
  display: none;
}
.cityBox {
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: 1px dotted #9cacff;
  padding: 15px 1px;
}
.city {
  /* padding: 11px 40px; */
  margin-right: 40px;
  width: 140px;
}
.zhan {
  padding: 20px 30px;
}
.xq {
  display: flex;
  align-items: center;
  /* padding: 11px 40px; */
}
.xq > img {
  width: 20px;
  height: 20px;
  margin-right: 7px;
}
.xq > span {
  width: 292px;
}
@media screen and (max-width: 479px) {
  .Page {
    width: 177%;
  }
  /* #chartChongqing {
    width: 30%;
  } */
  #box {
    width: 60%;
  }
}
</style>
